<div class="cerrix-financial-impact">
    <div class="body" #body>
        <div class="table-header">
            <div>Currency</div>
            <div>Gross impact</div>
            <div>Insured</div>
            <div>Other recovery</div>
            <div>Net impact</div>
        </div>
        @for (row of financialImpact.rows; track $index) {
            <div class="table-row">
                <div class="org-thirdparty">
                    <div
                        class="org-thirdparty-name"
                        [attr.data-uiid]="'financial-impact-component-table-name-text-row-' + $index"
                    >
                        @switch (row.type) {
                            @case ("internal-organization") {
                                <cerrix-icon
                                    icon="internal-organization"
                                    [size]="12"
                                    color="#001A41"
                                ></cerrix-icon>
                            }
                            @case ("third-party") {
                                <cerrix-icon
                                    icon="third-party"
                                    [size]="16"
                                    color="#001A41"
                                ></cerrix-icon>
                            }
                        }
                        <span>{{ row.name }}</span>
                    </div>
                    @if (!disabled) {
                        <cerrix-icon
                            class="close"
                            icon="close-small"
                            [size]="14"
                            color="#69729F"
                            (click)="removeRow($index)"
                        ></cerrix-icon>
                    }
                </div>
                @if (forceSingleCurrency) {
                    <cerrix-select
                        class="cerrix-select"
                        [disabled]="disabled"
                        [options]="currencyOptions"
                        [showNone]="false"
                        [ngModel]="_selectedCurrency"
                        (ngModelChange)="updateAllCurrency($event)"
                        [dataUiid]="'financial-impact-component-table-single-currency-select-row-' + $index"
                    ></cerrix-select>
                } @else {
                    <cerrix-select
                        class="cerrix-select"
                        [disabled]="disabled"
                        [options]="currencyOptions"
                        [showNone]="false"
                        [ngModel]="row.currencyId"
                        (ngModelChange)="updateCurrency($event, row)"
                        [dataUiid]="'financial-impact-component-table-currency-select-row-' + $index"
                    ></cerrix-select>
                }
                <cerrix-input-currency
                    placeholder="0,00"
                    [disabled]="disabled"
                    [autocomplete]="false"
                    [value]="row.gross"
                    (valueChange)="row.gross = $event; updateFinancialImpact(row)"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-gross-input-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    placeholder="0,00"
                    [disabled]="disabled"
                    [autocomplete]="false"
                    [value]="row.insured"
                    (valueChange)="row.insured = $event; updateFinancialImpact(row)"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-insured-input-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    placeholder="0,00"
                    [disabled]="disabled"
                    [autocomplete]="false"
                    [value]="row.otherRecovery"
                    (valueChange)="row.otherRecovery = $event; updateFinancialImpact(row)"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-other-recovery-input-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    [disabled]="true"
                    [value]="row.total"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-net-impact-input-row-' + $index"
                ></cerrix-input-currency>
            </div>
        }
    </div>
    @if (!disabled) {
        <div class="add-row">
            <div (click)="openDialog()" [attr.data-uiid]="'financial-impact-component-table-add-row-button'">
                <cerrix-icon icon="add" [size]="14" color="#0c66e4"></cerrix-icon>
                <span>Add row(s)</span>
            </div>
        </div>
    }
    <div class="totals" (scroll)="onScroll($event)">
        @for (row of financialImpact.totals; track $index) {
            <div class="table-row">
                <div [attr.data-uiid]="'financial-impact-component-table-total-row-' + $index">
                    Total: {{ row.name }}
                </div>
                <cerrix-select
                    [options]="currencyOptions"
                    [disabled]="true"
                    [selected]="row.currencyId"
                    [attr.data-uiid]="'financial-impact-component-table-currency-total-row-' + $index"
                ></cerrix-select>
                <cerrix-input-currency
                    [disabled]="true"
                    [value]="row.gross"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-gross-total-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    [disabled]="true"
                    [value]="row.insured"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-insured-total-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    [disabled]="true"
                    [value]="row.otherRecovery"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-other-recovery-total-row-' + $index"
                ></cerrix-input-currency>
                <cerrix-input-currency
                    [disabled]="true"
                    [value]="row.total"
                    [currencyPrefix]="row.currencyPrefix"
                    [attr.data-uiid]="'financial-impact-component-table-net-impact-total-row-' + $index"
                ></cerrix-input-currency>
            </div>
        }
    </div>
</div>

<ng-template #addRowDialog>
    <div class="cerrix-dialog">
        <div class="cerrix-dialog-header">
            <h2 mat-dialog-title class="cerrix-dialog-title">Select New</h2>
            <div mat-dialog-close class="cerrix-dialog-close">
                <mat-icon>close</mat-icon>
            </div>
        </div>
        <mat-dialog-content class="cerrix-dialog-body outlined">
            <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab
                    labelClass="cerrix-mat-tab"
                    [disabled]="
                        internalOrganizations === undefined || internalOrganizations.length === 0
                    "
                >
                    <ng-template mat-tab-label>
                        <span data-uiid="financial-impact-select-new-popup-internal-tab"
                            >Internal</span
                        >
                    </ng-template>
                    @if (internalOrganizations !== undefined) {
                        <cerrix-tree
                            [multiple]="true"
                            [treeData]="internalOrganizations"
                            [dataUiid]="
                                'financial-impact-select-new-popup-internal-organization-tree'
                            "
                        >
                        </cerrix-tree>
                    }
                </mat-tab>
                <mat-tab
                    labelClass="cerrix-mat-tab"
                    [disabled]="thirdParties === undefined || thirdParties.length === 0"
                >
                    <ng-template mat-tab-label>
                        <span data-uiid="financial-impact-select-new-popup-third-party-tab"
                            >Third party</span
                        >
                    </ng-template>
                    @if (thirdParties !== undefined) {
                        <cerrix-selectable-list
                            [selectableList]="thirdParties"
                            [dataUiid]="'financial-impact-select-new-popup-third-party-list'"
                        ></cerrix-selectable-list>
                    }
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <div class="cerrix-dialog-footer">
            <div class="cerrix-dialog-footer-buttons align-right">
                <cerrix-button
                    color="accent"
                    [mat-dialog-close]="true"
                    [dataUiid]="'financial-impact-select-new-popup-cancel-button'"
                    >Cancel</cerrix-button
                >
                <cerrix-button
                    color="success"
                    (click)="onApply()"
                    [disabled]="dialogItemsSelected"
                    [dataUiid]="'financial-impact-select-new-popup-add-selection-button'"
                    ><ng-container>Add selection</ng-container></cerrix-button
                >
            </div>
        </div>
    </div>
</ng-template>
